/* MEDIA PLAYER ***************************************************************/

// libs
import Cookies from 'js-cookie'
import _ from 'lodash'

// rest webservice api abstraction
import * as api from 'api'

// actions
import { getItem, getSurfaceItem } from 'react-redux/selectors/media-player'
import { getItem as getAssetItem } from 'react-redux/selectors/asset'
import { fetchItems as fetchPlaylistItems } from 'react-redux/actions/playlist'
import { hideModal } from 'react-redux/actions/modal'
import {
  push as pushNotification,
  pull as pullNotification
} from 'react-redux/actions/notification'
import { findRelated } from 'react-redux/actions/highlight'
import { makeEmptyPlaylist, makeMediaObject } from 'react-redux/actions/playlist'

// utils
import { randomString } from 'util/string'

// constants
import * as notificationType from 'component/notification/type'


import { SUCCESS_SUFFIX, FAIL_SUFFIX, PROGRESS_SUFFIX } from 'util/dataprovider'
import { makeAction } from 'util/reduxhelper'

/* FETCH MEDIA PLAYERS ********************************************************/

export const FETCH_ITEMS = 'mediaPlayer/list/FETCH_ITEMS'
export const fetchItems = (params) => {
  return (dispatch, getState) => {
    params = params || {}
    const state = getState()
    const { sort, pagination, pendingQuery } = state.mediaPlayer.list
    if (!pendingQuery){
      if (!params.hasOwnProperty("max_results"))
        params.max_results = pagination.maxResults
      if (!params.hasOwnProperty("page"))
        params.page = pagination.page
      if (!params.hasOwnProperty("sort_by_field"))
        params.sort_by_field = sort.field
      if (!params.hasOwnProperty("reverse_order"))
        params.reverse_order = sort.reverse[sort.field]
      dispatch(makeAction(FETCH_ITEMS, params))
    }
  }
}
/* automated for convenience @see dataprovider */
export const FETCH_ITEMS_FAIL = FETCH_ITEMS + FAIL_SUFFIX
export const FETCH_ITEMS_SUCCESS = FETCH_ITEMS + SUCCESS_SUFFIX

export const NEXT_PAGE = 'mediaPlayer/list/NEXT_PAGE'
export const nextPage = () => {
  return makeAction(NEXT_PAGE)
}

/* FETCH METADATA *************************************************************/

export const FETCH_ITEM = 'mediaPlayer/list/FETCH_ITEM'
export const fetchItem = (uid) => {
  return makeAction(FETCH_ITEM, {uid})
}
/* automated for convenience @see dataprovider */
export const FETCH_ITEM_FAIL = FETCH_ITEM + FAIL_SUFFIX
export const FETCH_ITEM_SUCCESS = FETCH_ITEM + SUCCESS_SUFFIX

/* FETCH STATUS ***************************************************************/

export const FETCH_ITEM_STATUS = 'mediaPlayer/list/FETCH_ITEM_STATUS'
export const fetchItemStatus = (uid) => {
  return makeAction(FETCH_ITEM_STATUS, {uid})
}
/* automated for convenience @see dataprovider */
export const FETCH_ITEM_STATUS_FAIL = FETCH_ITEM_STATUS + FAIL_SUFFIX
export const FETCH_ITEM_STATUS_SUCCESS = FETCH_ITEM_STATUS + SUCCESS_SUFFIX


export const FETCH_ITEMS_STATUS = 'mediaPlayer/list/FETCH_ITEMS_STATUS'
export const fetchItemsStatus = () => {
  return makeAction(FETCH_ITEMS_STATUS)
}
/* automated for convenience @see dataprovider */
export const FETCH_ITEMS_STATUS_FAIL = FETCH_ITEMS_STATUS + FAIL_SUFFIX
export const FETCH_ITEMS_STATUS_SUCCESS = FETCH_ITEMS_STATUS + SUCCESS_SUFFIX


/* FETCH SURFACES *************************************************************/

export const FETCH_ITEM_SURFACES = 'mediaPlayer/list/FETCH_ITEM_SURFACES'
export const fetchItemSurfaces = (uid) => {
  return makeAction(FETCH_ITEM_SURFACES, {uid})
}
/* automated for convenience @see dataprovider */
export const FETCH_ITEM_SURFACES_FAIL = FETCH_ITEM_SURFACES + FAIL_SUFFIX
export const FETCH_ITEM_SURFACES_SUCCESS = FETCH_ITEM_SURFACES + SUCCESS_SUFFIX


export const FETCH_ITEM_SURFACE = 'mediaPlayer/list/FETCH_ITEM_SURFACE'
export const fetchItemSurface = (mediaPlayerId, surfaceId) => {
  return makeAction(FETCH_ITEM_SURFACE, {mediaPlayerId, surfaceId})
}
/* automated for convenience @see dataprovider */
export const FETCH_ITEM_SURFACE_FAIL = FETCH_ITEM_SURFACE + FAIL_SUFFIX
export const FETCH_ITEM_SURFACE_SUCCESS = FETCH_ITEM_SURFACE + SUCCESS_SUFFIX


/* SAVE NAME *****************************************************************/

export const SAVE_NAME = 'mediaPlayer/edit/SAVE_NAME'
export const saveName = (uid, name) => {
  return (dispatch, getState) => {
    const metaData = _.cloneDeep(getItem(getState(), uid).metaData)
    metaData.name = name
    dispatch(makeAction(SAVE_NAME, { uid, item: metaData }))
  }
}
/* automated for convenience @see dataprovider */
export const SAVE_NAME_FAIL = SAVE_NAME + FAIL_SUFFIX
export const SAVE_NAME_SUCCESS = SAVE_NAME + SUCCESS_SUFFIX


/* SAVE DESCRIPTION ***********************************************************/

export const SAVE_DESCRIPTION = 'mediaPlayer/edit/SAVE_DESCRIPTION'
export const saveDescription = (uid, description) => {
  return (dispatch, getState) => {
    const metaData = _.cloneDeep(getItem(getState(), uid).metaData)
    metaData.description = description
    dispatch(makeAction(SAVE_DESCRIPTION, { uid, item: metaData }))
  }
}
/* automated for convenience @see dataprovider */
export const SAVE_DESCRIPTION_FAIL = SAVE_DESCRIPTION + FAIL_SUFFIX
export const SAVE_DESCRIPTION_SUCCESS = SAVE_DESCRIPTION + SUCCESS_SUFFIX



/* SAVE TAGS ******************************************************************/

export const SAVE_TAGS = 'mediaPlayer/edit/SAVE_TAGS'
export const saveTags = (uid, tags) => {
  return (dispatch, getState) => {
    const metaData = _.cloneDeep(getItem(getState(), uid).metaData)
    metaData.tags = tags
    dispatch(makeAction(SAVE_TAGS, { uid, item: metaData }))
  }
}
/* automated for convenience @see dataprovider */
export const SAVE_TAGS_FAIL = SAVE_TAGS + FAIL_SUFFIX
export const SAVE_TAGS_SUCCESS = SAVE_TAGS + SUCCESS_SUFFIX


/* FETCH GRAPHICS OUTPUT ******************************************************/

export const FETCH_GRAPHICS_OUTPUT = 'mediaPlayer/snapshot/FETCH_GRAPHICS_OUTPUT'
export const fetchGraphicsOutput = (uid) => {
  return makeAction(FETCH_GRAPHICS_OUTPUT, {uid})
}
/* automated for convenience @see dataprovider */
export const FETCH_GRAPHICS_OUTPUT_FAIL = FETCH_GRAPHICS_OUTPUT + FAIL_SUFFIX
export const FETCH_GRAPHICS_OUTPUT_SUCCESS = FETCH_GRAPHICS_OUTPUT + SUCCESS_SUFFIX

/* FETCH GRAPHICS IMAGE ******************************************************/

export const FETCH_CAMERA_IMAGE = 'mediaPlayer/snapshot/FETCH_CAMERA_IMAGE'
export const fetchCameraImage = (uid) => {
  return makeAction(FETCH_CAMERA_IMAGE, {uid})
}
/* automated for convenience @see dataprovider */
export const FETCH_CAMERA_IMAGE_FAIL = FETCH_CAMERA_IMAGE + FAIL_SUFFIX
export const FETCH_CAMERA_IMAGE_SUCCESS = FETCH_CAMERA_IMAGE + SUCCESS_SUFFIX


/* FILTER *********************************************************************/

/* Fetch */
export const FETCH_FILTER = 'mediaPlayer/list/FETCH_FILTER'
export const fetchFilter = () => {
  return makeAction(FETCH_FILTER)
}
/* automated for convenience @see dataprovider */
export const FETCH_FILTER_FAIL = FETCH_FILTER + FAIL_SUFFIX
export const FETCH_FILTER_SUCCESS = FETCH_FILTER + SUCCESS_SUFFIX

/* Save */
export const SAVE_FILTER = 'mediaPlayer/list/SAVE_FILTER'
export const saveFilter = (filter) => {
  return makeAction(SAVE_FILTER, filter)
}
/* automated for convenience @see dataprovider */
export const SAVE_FILTER_FAIL = SAVE_FILTER + FAIL_SUFFIX
export const SAVE_FILTER_SUCCESS = SAVE_FILTER + SUCCESS_SUFFIX

/* SORT ***********************************************************************/

/* Fetch */
export const FETCH_SORT = 'mediaPlayer/list/FETCH_SORT'
export const fetchSort = () => {
  return makeAction(FETCH_SORT)
}
/* automated for convenience @see dataprovider */
export const FETCH_SORT_FAIL = FETCH_SORT + FAIL_SUFFIX
export const FETCH_SORT_SUCCESS = FETCH_SORT + SUCCESS_SUFFIX

/* Save */
export const SAVE_SORT = 'mediaPlayer/list/SAVE_SORT'
export const saveSort = (sort) => {
  return makeAction(SAVE_SORT, sort)
}
/* automated for convenience @see dataprovider */
export const SAVE_SORT_FAIL = SAVE_SORT + FAIL_SUFFIX
export const SAVE_SORT_SUCCESS = SAVE_SORT + SUCCESS_SUFFIX


/* EXPAND AND COLLAPSE ********************************************************/

export const COLLAPSE = 'mediaPlayer/list/COLLAPSE'
export const collapse = (uid) => {
  return (dispatch) => {
    dispatch({ type: COLLAPSE, uid })
    let expanded = {}
    if(localStorage.mediaPlayerExpanded)
      expanded = JSON.parse(localStorage.mediaPlayerExpanded)
    delete expanded[uid]
    localStorage.mediaPlayerExpanded = JSON.stringify(expanded)
  }
}

export const EXPAND = 'mediaPlayer/list/EXPAND'
export const expand = (uid) => {
  return dispatch => {
    dispatch({ type: EXPAND, uid })
    let expanded = {}
    if(localStorage.mediaPlayerExpanded)
      expanded = JSON.parse(localStorage.mediaPlayerExpanded)
    expanded[uid] = true
    localStorage.setItem("mediaPlayerExpanded",JSON.stringify(expanded))
  }
}

export const SET_EXPANDED = 'mediaPlayer/list/SET_EXPANDED'
export const setExpanded = (expanded) => {
  return { type: SET_EXPANDED, expanded }
}

/**
* Retrieve expanded status from local storage
*/
export const FETCH_EXPANDED = 'mediaPlayer/list/FETCH_EXPANDED'
export const fetchExpanded = (uid) => {
  return (dispatch) => {
    dispatch({ type: FETCH_EXPANDED, uid })
    let expanded = {}
    if(localStorage.mediaPlayerExpanded)
      expanded = JSON.parse(localStorage.mediaPlayerExpanded)
    dispatch(setExpanded(expanded))
  }
}

/* SYNC HINT ******************************************************************/

export const SET_SYNC_HINT_BY_PLAYLIST = 'mediaPlayer/list/SET_SYNC_HINT_BY_PLAYLIST'
export const setSyncHintByPlaylist = (uid) => {
  return (dispatch, getState) => {
    dispatch({ type: SET_SYNC_HINT_BY_PLAYLIST, uid })
    const { surfaces } = getState().mediaPlayer.list
    _.each(surfaces, (mediaPlayerSurfaces, mediaPlayerId) => {
      _.each(mediaPlayerSurfaces, (surface, surfaceId) => {
        if (surface.playlistId && surface.playlistId === uid) {
            dispatch(setSyncHint(mediaPlayerId, true))
        }
      })
    })
  }
}

export const SET_SYNC_HINT = 'mediaPlayer/list/SET_SYNC_HINT'
export const setSyncHint = (uid, value) => {
    return { type: SET_SYNC_HINT, uid, value}
}


/* SYNC SURFACES **************************************************************/

export const SYNC_SURFACES = 'mediaPlayer/edit/SYNC_SURFACES'
export const syncSurfaces = (uid) => {
  return makeAction(SYNC_SURFACES, {uid})
}
/* automated for convenience @see dataprovider */
export const SYNC_SURFACES_FAIL = SYNC_SURFACES + FAIL_SUFFIX
export const SYNC_SURFACES_SUCCESS = SYNC_SURFACES + SUCCESS_SUFFIX


/* SYNC MEDIA PLAYER **********************************************************/

export const SYNC_MEDIA_PLAYER = 'mediaPlayer/edit/SYNC_MEDIA_PLAYER'
export const syncMediaPlayer = (uid) => {
  return makeAction(SYNC_MEDIA_PLAYER, {uid})
}
/* automated for convenience @see dataprovider */
export const SYNC_MEDIA_PLAYER_FAIL = SYNC_MEDIA_PLAYER + FAIL_SUFFIX
export const SYNC_MEDIA_PLAYER_SUCCESS = SYNC_MEDIA_PLAYER + SUCCESS_SUFFIX

/* Bulk booking */

export const BULK_ASSIGN_PLAYLIST = 'mediaPlayer/edit/BULK_ASSIGN_PLAYLIST'
export const bulkAssignPlaylist = (playlistId, filter) => {
  return makeAction(BULK_ASSIGN_PLAYLIST, {playlistId, filter})
}
/* automated for convenience @see dataprovider */
export const BULK_ASSIGN_PLAYLIST_FAIL = BULK_ASSIGN_PLAYLIST + FAIL_SUFFIX
export const BULK_ASSIGN_PLAYLIST_SUCCESS = BULK_ASSIGN_PLAYLIST + SUCCESS_SUFFIX


export const BULK_ASSIGN_ASSET = 'mediaPlayer/edit/BULK_ASSIGN_ASSET'
export const bulkAssignAsset = (assetId, filter) => {
  //console.log("bulkAssignAsset", assetId)
  return (dispatch, getState) => {
    const asset = getAssetItem(getState(), assetId)
    const playlist = makeEmptyPlaylist(asset.name)
    playlist.mediaObjects.push(makeMediaObject(getState, assetId))
    //console.log("playlist to assign", playlist)
    dispatch(makeAction(BULK_ASSIGN_ASSET, playlist, {filter}))
  }
}
/* automated for convenience @see dataprovider */
export const BULK_ASSIGN_ASSET_FAIL = BULK_ASSIGN_ASSET + FAIL_SUFFIX
export const BULK_ASSIGN_ASSET_SUCCESS = BULK_ASSIGN_ASSET + SUCCESS_SUFFIX

/* Bulk syncing */
export const BULK_SYNC = 'mediaPlayer/edit/BULK_SYNC'
export const bulkSync = (filter) => {
  return makeAction(BULK_SYNC, {filter})
}
/* automated for convenience @see dataprovider */
export const BULK_SYNC_FAIL = BULK_SYNC + FAIL_SUFFIX
export const BULK_SYNC_SUCCESS = BULK_SYNC + SUCCESS_SUFFIX



// WEBPACK FOOTER //
// ./src/app/react-redux/actions/media-player.js